import { matchSorter } from 'match-sorter'

import { DESC, MENU_ID } from './constants'

/**
 * Accesses a nested property defined by a string.
 * @param {Object} object The object that contains the key
 * @param {String} key The key to look for. Can be nested e.g. "user.name"
 */
const getValue = (object, key) => {
  return key.split('.').reduce((obj, prop) => {
    return obj[prop]
  }, object)
}
/**
 * Generic descending sort function for a list of objects.
 * @param {Object} rowA A row of data from the table
 * @param {Object} rowB Another row of data from the table
 * @param {String} sortBy The column ID which to sort by
 */
const desc = (rowA, rowB, sortBy) => {
  if (getValue(rowB, sortBy) < getValue(rowA, sortBy)) {
    return -1
  }

  if (getValue(rowB, sortBy) > getValue(rowA, sortBy)) {
    return 1
  }

  return 0
}
const getColumnActions = columns => {
  const actions = { sorters: {}, renderers: {}, searchKeys: [] }

  columns.forEach(column => {
    // sorters
    if (typeof column.sort === 'function') {
      actions.sorters[column.id] = column.sort
    } else {
      actions.sorters[column.id] = (rowA, rowB, direction) => {
        const order = direction === DESC ? 1 : -1

        return order * desc(rowA, rowB, column.id)
      }
    }

    // renderers
    if (typeof column.render === 'function') {
      actions.renderers[column.id] = column.render
    } else {
      actions.renderers[column.id] = row => getValue(row, column.id)
    }

    // searchFields
    if (Array.isArray(column.searchKeys)) {
      const normalizedSearchKeys = column.searchKeys.map(key => ({
        id: column.id,
        type: 'string',
        ...key
      }))

      actions.searchKeys.push(...normalizedSearchKeys)
    } else if (column.id && column.id !== MENU_ID) {
      actions.searchKeys.push({ id: column.id, type: 'string' })
    }
  })

  return actions
}
const getFilteredData = ({ data, query, searchKeys, searchType }) => {
  switch (searchType) {
    case 'fuzzy': {
      const filteredData = matchSorter(data, query, {
        keys: searchKeys.map(key => key.id),
        threshold: matchSorter.rankings.CONTAINS
      })

      return filteredData
    }
    case 'matches': {
      // case-insensitive inclusion
      let filteredData = data

      if (query) {
        filteredData = filteredData.filter(row => {
          return searchKeys.some(key => {
            const value = getValue(row, key.id)

            if (typeof value === 'undefined') {
              return false
            }

            return value.toString().toLowerCase().includes(query.toLowerCase())
          })
        })
      }

      return filteredData
    }
    default: {
      // exact
      let filteredData = data

      if (query) {
        filteredData = filteredData.filter(row =>
          searchKeys.some(key => {
            const value = getValue(row, key.id)

            if (typeof value === 'undefined') {
              return false
            }

            return value.toString() === query
          })
        )
      }

      return filteredData
    }
  }
}
const formatNumber = number => Intl.NumberFormat().format(number)
const getIntArray = size => Array.from(new Array(size), (int, idx) => idx + 1)

export { getColumnActions, getFilteredData, getIntArray, getValue, formatNumber }
